import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider, useTranslation } from "react-i18next";
import { useEffect } from "react";
import i18n from "./i18n";

function GlobalMeta() {
  const { i18n: translationI18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = translationI18n.language.startsWith('en') ? 'en' : 'ja';
    if (translationI18n.language.startsWith('en')) {
      document.title = "Visipo | Walking App - A journey in your pocket";
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute("content", "Visipo is a walking app integrating your pedometer and Google Maps. Enjoy various routes worldwide with AI diaries and voice narration. Free to download.");
    } else {
      document.title = "Visipo（ビジポ） | 歩数で世界を旅するウォーキングアプリ – ポケットに入れて持ち歩ける旅";
      const metaDesc = document.querySelector('meta[name="description"]');
      if (metaDesc) metaDesc.setAttribute("content", "Visipo（ビジポ）は歩数計とGoogle Mapsを連動させた旅するウォーキングアプリ。四国遍路・東海道五十三次などの多彩なルートをAI日記と音声読み上げで楽しめます。無料ダウンロード。");
    }
  }, [translationI18n.language]);

  return null;
}
function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <GlobalMeta />
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
